import { mapActions } from 'vuex'
import gsap from 'gsap'

export default {
  name: 'Login',
  components: {},
  props: {},
  data: function () {
    return {
      usuario: '',
      password: '',
      showPassword: false,
      loading: false
    }
  },
  mounted () {
    this._animateEntrance()
  },
  methods: {
    ...mapActions(['GetToken']),

    login () {
      if (this.loading) return
      this.loading = true
      const credenciales = { usernameOrEmail: this.usuario, password: this.password }
      this.GetToken(credenciales).then((res) => {
        if (!res) {
          this.$bvToast.toast('Usuario o Clave incorrectas', {
            title: 'Fallo Inicio de sesión',
            variant: 'danger',
            solid: true
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },

    togglePassword () {
      this.showPassword = !this.showPassword
    },

    _animateEntrance () {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      const dur = prefersReduced ? 0 : 0.6
      const ease = 'power3.out'

      const tl = gsap.timeline()

      tl.fromTo(this.$refs.card,
        { autoAlpha: 0, y: 28, scale: 0.97 },
        { autoAlpha: 1, y: 0, scale: 1, duration: dur, ease, clearProps: 'transform' })

      tl.fromTo(this.$refs.logo,
        { autoAlpha: 0, y: -10 },
        { autoAlpha: 1, y: 0, duration: dur * 0.7, ease },
        '-=0.3')
    }
  },
  computed: {}
}
